import { render, staticRenderFns } from "./CaseAnalytics.vue?vue&type=template&id=e4239660&scoped=true"
import script from "./CaseAnalytics.vue?vue&type=script&lang=js"
export * from "./CaseAnalytics.vue?vue&type=script&lang=js"
import style0 from "./CaseAnalytics.vue?vue&type=style&index=0&id=e4239660&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e4239660",
  null
  
)

export default component.exports